import { LocalStorageService } from '@app/core/services/web-storage.service';
import { Languages } from '@app/core/models';
import * as i0 from "@angular/core";
import * as i1 from "./web-storage.service";
var LanguageService = /** @class */ (function () {
    function LanguageService(localStorage) {
        this.localStorage = localStorage;
        this.languages = Languages;
    }
    LanguageService.prototype.saveSelectedLanguage = function (language) {
        this.localStorage.set('language', language.code);
    };
    LanguageService.prototype.getSelectedLanguage = function () {
        var languageCode = this.localStorage.get('language');
        return languageCode ? this.getLanguageByCode(languageCode) : null;
    };
    LanguageService.prototype.getLanguage = function (key) {
        return this.languages[key];
    };
    LanguageService.prototype.getLanguageByCode = function (code) {
        for (var _i = 0, _a = Object.keys(Languages); _i < _a.length; _i++) {
            var lang = _a[_i];
            if (Languages[lang].code === code) {
                return Languages[lang];
            }
        }
        return null;
    };
    LanguageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LanguageService_Factory() { return new LanguageService(i0.ɵɵinject(i1.LocalStorageService)); }, token: LanguageService, providedIn: "root" });
    return LanguageService;
}());
export { LanguageService };
